// extracted by css-extract-rspack-plugin
export default {"container":"_2b105fb1","wrapper":"_1eabb665","questionList":"_708982da","question":"_cbe31a98","questionLink":"_308261b8"};